import firebase from 'firebase/app';
import 'firebase/database';

export const initializeFirebase = () => {
    var config = {
        apiKey: "AIzaSyAlvmOgvKZp_Uzd7KuxLPFdk4hi9ex6tTI",
        authDomain: "database-ra.firebaseapp.com",
        databaseURL: "https://database-ra-default-rtdb.firebaseio.com",
        projectId: "database-ra",
        storageBucket: "database-ra.appspot.com",
        messagingSenderId: "147582930767",
        appId: "1:147582930767:web:74c35a5787652a8db9bf3a",
        measurementId: "G-MYGE9PZS0E"
    };
    firebase.initializeApp(config);
}

export const getAll = () => {
    if (!firebase.apps.length) {
        initializeFirebase();
    }
    // firebase.database().ref().child(id).on('value', snap => console.log(snap.val()));
    firebase.database().ref().once('value').then(snap => console.log(snap.val()));
}

